export const environment = {
  production: true,
  envName: 'production',
  apiUrl: 'https://api.salis.ae/api',
  sentryDsn:
    'https://73dc45848ef6cb50549f5316a02e76ab@o4511852802080768.ingest.de.sentry.io/4511858533466192',
  // Reverb WebSockets (public key; must match REVERB_APP_KEY in salis-be .env)
  reverb: {
    key: 'og4ck6hjek8fsun7xqd8',
    host: 'api.salis.ae',
    port: 443,
    scheme: 'https',
  },
  firebaseConfig: {
    apiKey: 'AIzaSyB1ehpDYRHznTz2svizCYFOjz1NmRRjr6c',
    authDomain: 'salis-group.firebaseapp.com',
    projectId: 'salis-group',
    storageBucket: 'salis-group.firebasestorage.app',
    messagingSenderId: '982856433844',
    appId: '1:982856433844:web:0600fddadaee6c9d1dd7e1',
    measurementId: 'G-F8EMRNGEFK',
  },
};
